<div
  id="metricZoom"
  [ngClass]="
    subAreaDropdown && subAreaDropdown.length > 1
      ? 'lightbox-with-subareas'
      : 'lightbox'
  "
>
  <div class="top-row">
    <div class="header">{{ data.lightbox.title }}</div>
    <div class="buttons" data-html2canvas-ignore="true">
      <button mat-raised-button class="close-btn" (click)="close()" alt="Close">
        CLOSE
      </button>
    </div>
  </div>
  <div class="subtitle">{{ data.lightbox.definition }}</div>
  <div class="timePeriodTitle sub-header">CHOOSE TIME PERIOD</div>
  <div class="timePeriod">
    <time-period-btn-group
      *ngFor="let timePeriod of data.lightbox.timePeriodLabels"
      [timePeriod]="timePeriod"
      [toggleDisabled]="
        exportingData ||
        !chartData ||
        chartData.length < 1 ||
        !chartData[0] ||
        !chartData[0].data ||
        chartData[0].data.length < 1 ||
        loading
      "
      (labelToggledEvent)="toggleTimePeriodLabel($event)"
      (yearSelectedEvent)="toggleYear($event)"
    ></time-period-btn-group>
  </div>
  <div class="filters">
    <div
      class="subArea zoom-select"
      *ngIf="subAreaDropdown && subAreaDropdown.length > 1"
    >
      <h2 class="sub-header dropdown-header">CHOOSE CONTENT</h2>
      <ng-select
        [items]="subAreaDropdown"
        [(ngModel)]="selectedSubArea"
        (change)="toggleSubAreaVisibility()"
        [clearable]="false"
        [searchable]="false"
        *ngIf="selectedChart != 'distribution'"
        [disabled]="loading"
        class="subarea-select"
      ></ng-select>
      <div class="subAreaPlaceholder" *ngIf="selectedChart == 'distribution'">
        Overall
      </div>
      <div
        class="subAreaOptions"
        *ngIf="subAreaOptions && subAreaOptions.length > 0"
      >
        <checkbox-multiselect
          [filterDropdown]="subAreaOptions"
          [groupBy]="'field'"
          [placeholder]="'Select Content'"
          [selectedFilterVals]="selectedSubAreaOptions"
          [buttonText]="'Clear'"
          [categoryAttribute]="'field'"
          [itemAttribute]="'subfield.name'"
          [numItemsShown]="3"
          [searchable]="true"
          (filtersSelectedEvent)="subAreasSelected($event)"
          (unselectAllFiltersEvent)="unselectAllSubAreas()"
          (clearItemEvent)="clearSubArea($event)"
          [disabled]="loading"
          [applyToFilter]="true"
        >
        </checkbox-multiselect>
      </div>
      <div
        class="no-content-warning"
        *ngIf="
          subAreaOptions &&
          subAreaOptions.length > 0 &&
          (!selectedSubAreaOptions || selectedSubAreaOptions.length < 1)
        "
      >
        Select at least one item!
      </div>
    </div>
    <div class="filter zoom-select">
      <h2 class="sub-header dropdown-header">FILTER BY</h2>
      <checkbox-multiselect
        data-id="MetricZoom.FilterBy"
        [filterDropdown]="filterDropdown"
        [groupBy]="'field'"
        [placeholder]="'All My Students'"
        [selectedFilterVals]="selectedFilterVals"
        [buttonText]="'All My Students (no filter)'"
        [categoryAttribute]="'field'"
        [itemAttribute]="'subfield.name'"
        [numItemsShown]="3"
        [searchable]="true"
        (filtersSelectedEvent)="filtersSelected($event)"
        (unselectAllFiltersEvent)="unselectAllFilters()"
        (clearItemEvent)="clear($event)"
        [disabled]="loading"
        [applyToFilter]="true"
      ></checkbox-multiselect>
    </div>
    <div class="compareBySelect zoom-select">
      <h2 class="sub-header dropdown-header">COMPARE BY</h2>
      <ng-select
        data-id="MetricZoom.CompareBy"
        [items]="compareByDropdown"
        [(ngModel)]="selectedCompareBy"
        (change)="selectCompareBy()"
        [clearable]="false"
        [searchable]="false"
        [placeholder]="noComparisonText"
        [disabled]="loading"
      ></ng-select>
    </div>
  </div>

  <div class="viewButtons" data-html2canvas-ignore="true">
    <mat-button-toggle-group
      [value]="viewType"
      (change)="changeViewType($event)"
    >
      <mat-button-toggle value="chart"> Graph </mat-button-toggle>
      <mat-button-toggle value="table"> Table </mat-button-toggle>
    </mat-button-toggle-group>
    <div class="export-btns">
      <button
        [disabled]="
          exportingData ||
          !chartData ||
          chartData.length < 1 ||
          !chartData[0] ||
          !chartData[0].data ||
          chartData[0].data.length < 1
        "
        (click)="exportToCSV()"
        class="export-btn"
      >
        <img [src]="'../../assets/images/export.svg'" />
        Export CSV
      </button>
      <button
        [disabled]="
          exportingData ||
          !chartData ||
          chartData.length < 1 ||
          !chartData[0] ||
          !chartData[0].data ||
          chartData[0].data.length < 1
        "
        (click)="exportToPNG()"
        class="export-btn"
      >
        <img [src]="'../../assets/images/download_active.svg'" />
        Export PNG
      </button>
    </div>
  </div>
  <div class="title">
    <ng-container *ngIf="contentText">{{ contentText }}</ng-container>
    <ng-container
      *ngIf="
        contentText &&
        ((selectedCompareBy && selectedCompareBy != noComparisonText) ||
          filterByText)
      "
    >
      &mdash;
    </ng-container>
    <ng-container
      *ngIf="selectedCompareBy && selectedCompareBy != noComparisonText"
      >Compared By: {{ selectedCompareBy }}</ng-container
    >
    <ng-container
      *ngIf="
        selectedCompareBy &&
        selectedCompareBy != noComparisonText &&
        filterByText
      "
    >
      &mdash;
    </ng-container>
    <ng-container *ngIf="filterByText"
      >Filtered By: {{ filterByText }}</ng-container
    >
    <ng-container
      *ngIf="
        (contentText ||
          (selectedCompareBy && selectedCompareBy != noComparisonText) ||
          filterByText) &&
        filterByCurrentlyEnrolled
      "
    >
      &mdash;
    </ng-container>
    <ng-container *ngIf="filterByCurrentlyEnrolled">{{
      filterByCurrentlyEnrolledText
    }}</ng-container>
  </div>
  <div class="viewPanel" *ngIf="viewType == 'chart'" [id]="selectedChart">
    <mz-trend-chart
      #MZTrendChart
      [viewType]="viewType"
      [chartData]="filteredChartData"
      [loading]="loading"
      [categories]="categories"
      [data]="data"
      [min]="min"
      [max]="max"
      [filterByText]="filterByText"
      [contentText]="contentText"
      [selectedCompareBy]="selectedCompareBy"
      [selectedSubArea]="selectedSubArea"
      [noComparisonText]="noComparisonText"
      (chartDataUpdated)="updateChartData($event)"
      (changeViewTypeEvent)="changeViewType($event)"
      (exportCSV)="exportToCSV()"
      class="mz-trend-chart"
      *ngIf="selectedChart == 'trend'"
    ></mz-trend-chart>
    <div id="chartDiv" class="chart" *ngIf="selectedChart == 'distribution'">
      <mz-info-message
        *ngIf="distHasLargeDataset && !isHiddenInLocalStorage()"
        [type]="selectedChart"
        (hideMZInfoMessage)="hideMZInfoMessage()"
      ></mz-info-message>
      <mat-progress-spinner
        class="modal-spinner"
        [diameter]="75"
        [mode]="'indeterminate'"
        *ngIf="loading"
      >
      </mat-progress-spinner>
      <p *ngIf="!loading && !chartData" class="load-info-text">
        No data available
      </p>
      <stacked-column-expanded
        #StackedColumnExpandedComponent
        [chartData]="filteredChartData"
        [dataPrefix]="data.lightbox.dataPrefix"
        [dataSuffix]="data.lightbox.dataSuffix"
        [filterByText]="filterByText"
        [compareByCategory]="selectedCompareBy"
        [noComparisonText]="noComparisonText"
        [roundTo]="data.lightbox.roundTo"
        [contentText]="contentText"
        [schools]="historical_schools"
        [showLabels]="distShowLabels"
        [selectedTimePeriods]="selectedTimePeriods"
        class="mz-stacked-column-expanded-chart"
        *ngIf="
          selectedChart == 'distribution' &&
          chartData &&
          chartData[0] &&
          chartData[0].data &&
          (chartData.length > 0 || chartData[0].data.length > 0)
        "
      ></stacked-column-expanded>
    </div>
  </div>
  <div class="viewPanel" *ngIf="viewType == 'table'">
    <div class="table">
      <mat-progress-spinner
        class="modal-spinner"
        [diameter]="75"
        [mode]="'indeterminate'"
        *ngIf="loading"
      >
      </mat-progress-spinner>
      <lightbox-table
        [columns]="selectedTimePeriods"
        [seriesData]="filteredChartData"
        [dataPrefix]="data.lightbox.dataPrefix"
        [dataSuffix]="data.lightbox.dataSuffix"
        [roundTo]="data.lightbox.roundTo"
        [descriptor]="tooltipDescriptor"
        [max]="max"
        [hidden]="loading"
        [compareBy]="selectedCompareBy"
        [historicalSchools]="historical_schools"
      ></lightbox-table>
    </div>
  </div>
  <div class="chartIcons" data-html2canvas-ignore="true">
    <chart-icon-button
      data-id="MetricZoom.Trend"
      [btnName]="'Trend'"
      [imgName]="'line_chart_icon'"
      [selected]="selectedChart == 'trend'"
      [kpiId]="data.lightbox.kpiId"
      [type]="'trend'"
      (click)="selectChart('trend')"
      *ngIf="data.lightbox.charts.trend && data.lightbox.charts.trend.chartData"
    ></chart-icon-button>
    <chart-icon-button
      data-id="MetricZoom.Distribution"
      [btnName]="'Distribution'"
      [imgName]="'stacked_bar_chart_icon'"
      *ngIf="
        data.lightbox.charts.category && data.lightbox.charts.category.chartData
      "
      [selected]="selectedChart == 'distribution'"
      [kpiId]="data.lightbox.kpiId"
      [type]="'distribution'"
      (click)="selectChart('distribution')"
      ></chart-icon-button>
    <chart-icon-button
      *ngIf="
        data.lightbox.otherReportsUrl
      "
      [btnName]="'Other Reports'"
      [imgName]="'other_reports'"
      [url]="data.lightbox.otherReportsUrl"
      [kpiId]="data.lightbox.kpiId"
      [type]="'otherReports'"
      ></chart-icon-button> 
  </div>
</div>
